module.exports = __webpack_public_path__ + "static/img/meiti3.938d9087.jpg";